export default function ProjectCard({
    name,
    desc,
    tech,
    date,
    linkName,
    url,
    association,
    project_kind
}) {
    return (
        <div className="d-flex flex-column justify-content-center border border-primary p-3 mb-2" style={{ minHeight: "243px" }}>
            <h2 className="name text-uppercase">{name}</h2>
            <div className="desc fw-light">{desc}</div>
            <div className="tech text-grey fw-light mt-1">{tech}</div>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mt-3">
                <div className="date fw-light">{date}</div>
                {linkName &&
                    <div className="link mt-2 mt-md-0">
                        <a  className="btn btn-outline-primary"   
                            role="button"
                            href={url}
                            rel="noopener noreferrer"
                            target="_blank">
                            {linkName}
                        </a>
                    </div>
                }
                {association &&
                    <div className="fw-light mt-2 mt-md-0">for <span className="text-uppercase fw-bold ms-2">{association}</span></div>
                }
                {project_kind &&
                    <div className="fw-light mt-2 mt-md-0">a <span className="text-uppercase fw-bold ms-2">{project_kind}</span></div>
                }
            </div>
        </div>
    )
}